import $ from 'jquery';
class Scrollto {

	constructor() {
		$(document).on('click', 'a[href^="#"]', (e) => this.scrollToElement(e));
	}

	scrollToElement(event) {

		if($(event.currentTarget).parent().hasClass('vc_tta-panel-title')) return event;
		if($(event.currentTarget).attr('id') == 'cn-accept-cookie') return event;

		var thishref = $(event.currentTarget).attr("href");
		var url = thishref.substr(thishref.indexOf("#"));

		if(url.length>1 && $(url).length){
			event.preventDefault();

			$('html, body').animate({
				scrollTop: parseInt($(url).offset().top - 0)
			}, 500);
		}
	}
}

new Scrollto